import { render, staticRenderFns } from "./StationPcm.vue?vue&type=template&id=0b35fcb7&scoped=true&"
import script from "./StationPcm.vue?vue&type=script&lang=ts&"
export * from "./StationPcm.vue?vue&type=script&lang=ts&"
import style0 from "./StationPcm.vue?vue&type=style&index=0&id=0b35fcb7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35fcb7",
  null
  
)

export default component.exports